module.exports = __webpack_public_path__ + "static/media/NSP01@s.652ae599.jpg";